import { cn } from '@/lib/tailwind-utils';
import { CoachPortalSession } from '@airreading/common/data';
import { useFeatureFlag } from '@airreading/feature-flags/web';
import { ClipboardCheck } from 'lucide-react';
import { useInAppAssessment } from './in-app-assessment-provider';
import { canRunInAppAssessments } from './in-app-assessment-utils';

/**
 * Opens the in-app assessment window for a class.
 *
 * Renders nothing unless the `in-app-pm-gla` flag is on and the class actually has in-app assessments
 * to run, which also keeps it hidden on the past-classes table since that view does not load them.
 */
export function InAppAssessmentTrigger({
  session,
  className,
  dataTestId,
}: {
  session: CoachPortalSession;
  className?: string;
  dataTestId?: string;
}) {
  const enabled = useFeatureFlag('in-app-pm-gla', false);
  const { open } = useInAppAssessment();

  if (!enabled || !canRunInAppAssessments(session)) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={() => open(session)}
      className={cn('inline-flex items-center gap-1 text-air-primary underline-offset-4 hover:underline', className)}
      data-testid={dataTestId}
    >
      <ClipboardCheck className="h-4 w-4" />
      Begin assessment
    </button>
  );
}
